import type { AnalyticsItem } from "~/sdk/ga4/types/index"

// `price` já é o preço líquido da etapa: o `discount` é informativo e não
// sai de novo do total (#285).
export const getTotalValue = (items: AnalyticsItem[]) => {
    const value = items
        .reduce(
            (acc, { price, quantity }) => acc + price * quantity,
            0,
        )
        .toFixed(2)

    return parseFloat(value)
}
